export default __webpack_public_path__ + "static/media/controlCenter.9ebf8d0f.svg";